<template>
  <div class="page">
    <BackNavigationBar :back="back" :title="title" :hide-button="hideBackButton"/>
    <slot />
  </div>
</template>

<script>
import BackNavigationBar from "@/components/layout/navigation/BackNavigationBar";
export default {
  name: "PageWithBackBtn",
  components: {BackNavigationBar},
  props : {
    back : {
      type : Function,
      default : function () { this.$router.back() }
    },
    hideBackButton : {
      type : Boolean,
      default : false,
    },
    title : {
      type : String,
      required : true
    }
  }
}
</script>

<style lang="scss" scoped>
.page {
  height: 100%;
  background: var(--bg-gradient);
  overflow-x: hidden;
  overflow-y: scroll;
  position: relative;
  font-family: var(--font-family);
  transition: var(--transition-speed);
}
</style>